import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { SharedData } from '@models/shareddata';

@Injectable()
export class SharedDataService {
  private sharedDataBetalingTeksten: Observable<SharedData[]>;
  private sharedDataCodeSoortVerzekering: Observable<SharedData[]>;
  private sharedDataDetailTitels: Observable<SharedData[]>;
  private sharedDataOpeningstijden: Observable<SharedData[]>;
  private sharedDataOplossingTeksten: Observable<SharedData[]>;
  private sharedDataTeksten: Observable<SharedData[]>;
  private sharedDataTeksten2: Observable<SharedData[]>;

  constructor(
    private _http: HttpService,
    @Inject('KANAAL') private kanaal: string
  ) { }

  getCodeSoortVerzekering(): Observable<SharedData[]> {
    if (this.sharedDataCodeSoortVerzekering) {
      return this.sharedDataCodeSoortVerzekering;
    }
    this.sharedDataCodeSoortVerzekering = this._http.get<SharedData[]>(environment.codeSoortVerzekeringUrl).pipe(share());
    return this.sharedDataCodeSoortVerzekering;
  }

  getBetalingTeksten(): Observable<SharedData[]> {
    if (this.sharedDataBetalingTeksten) {
      return this.sharedDataBetalingTeksten;
    }
    this.sharedDataBetalingTeksten = this._http.get<SharedData[]>(environment.betalingTekstenUrl).pipe(share());
    return this.sharedDataBetalingTeksten;
  }

  getDetailTitels(): Observable<SharedData[]> {
    if (this.sharedDataDetailTitels) {
      return this.sharedDataDetailTitels;
    }
    this.sharedDataDetailTitels = this._http.get<SharedData[]>(environment.detailTitelsUrl).pipe(share());
    return this.sharedDataDetailTitels;
  }

  getOpeningstijden(): Observable<SharedData[]> {
    if (this.sharedDataOpeningstijden) {
      return this.sharedDataOpeningstijden;
    }
    this.sharedDataOpeningstijden = this._http.get<SharedData[]>(environment.openingstijdenUrl).pipe(share());
    return this.sharedDataOpeningstijden;
  }

  getOplossingTeksten(): Observable<SharedData[]> {
    if (this.sharedDataOplossingTeksten) {
      return this.sharedDataOplossingTeksten;
    }
    this.sharedDataOplossingTeksten = this._http.get<SharedData[]>(environment.oplossingTekstenUrl).pipe(share());
    return this.sharedDataOplossingTeksten;
  }

  getTekst(tekst: string): Observable<string> {
    return this.getTeksten().pipe(map(sd => sd.find(({ Name }) => Name === (tekst))?.Phrase));
  }

  getTeksten(): Observable<SharedData[]> {
    if (this.sharedDataTeksten) {
      return this.sharedDataTeksten;
    } else {
      if (environment.production) {
        this.sharedDataTeksten = this._http.get<SharedData[]>(environment.tekstenUrl + '&kanaal=' + this.kanaal).pipe(share());
      } else {
        this.sharedDataTeksten = this._http.get<SharedData[]>(environment.tekstenUrl).pipe(share());
      }
      return this.sharedDataTeksten;
    }
  }
}
